/**
 * 共享组件库索引文件
 * 统一导出所有组件
 */

import StudentSelector from './StudentSelector.vue';
import DateRangePicker from './DateRangePicker.vue';
import DataTable from './DataTable.vue';
import ConfirmDialog from './ConfirmDialog.vue';
import FormGenerator from './FormGenerator.vue';

// 注册全局组件的函数
export const registerGlobalComponents = (app) => {
  app.component('StudentSelector', StudentSelector);
  app.component('DateRangePicker', DateRangePicker);
  app.component('DataTable', DataTable);
  app.component('ConfirmDialog', ConfirmDialog);
  app.component('FormGenerator', FormGenerator);
};

// 导出所有组件
export {
  StudentSelector,
  DateRangePicker,
  DataTable,
  ConfirmDialog,
  FormGenerator
};

// Vue插件形式
export default {
  install: (app) => {
    registerGlobalComponents(app);
  }
}; 